import React from 'react';
import { useIntl } from 'react-intl';
import { Popover, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from '@mui/icons-material/Article';

// Export-format picker anchored to an answer's download button. Shared by the
// single-report Ask Prompta chat and the compare-report chat so both offer the
// same two formats with the same styling.
const AnswerExportMenu = ({ anchorEl, onClose, onPdf, onWord }) => {
    const intl = useIntl();

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{ sx: { borderRadius: 2, minWidth: 160, boxShadow: 3 } }}
        >
            <MenuItem onClick={onPdf} sx={{ gap: 1 }}>
                <ListItemIcon sx={{ minWidth: 'auto' }}>
                    <PictureAsPdfIcon fontSize="small" color="error" />
                </ListItemIcon>
                <ListItemText primary={intl.formatMessage({ id: 'askPrompta.export_pdf', defaultMessage: 'Export as PDF' })} />
            </MenuItem>
            <MenuItem onClick={onWord} sx={{ gap: 1 }}>
                <ListItemIcon sx={{ minWidth: 'auto' }}>
                    <ArticleIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <ListItemText primary={intl.formatMessage({ id: 'askPrompta.export_word', defaultMessage: 'Export as Word' })} />
            </MenuItem>
        </Popover>
    );
};

export default AnswerExportMenu;
